import { useTranslation } from 'react-i18next';

import { Flex } from '@/lib/v2/components/Layout/Stack';

import { IFreeTrialDemo } from '@/src/presentation/types/interfaces/IFreeTrialDemo';

export const DemoTrialCounter = ({ freeTrialBlock }: { freeTrialBlock?: IFreeTrialDemo }) => {
  const { t } = useTranslation();
  if (!freeTrialBlock?.counter) {
    return (
      <div className="flex h-[33px] w-60 animate-pulse gap-2">
        <div className="w-full basis-2/3 rounded-md bg-gray-200"></div>
        <div className="h-full w-full basis-1/3 rounded-md bg-gray-200"></div>
      </div>
    );
  }

  return (
    <div className="inline-block text-[14px]">
      <Flex noGrow withGap gapSize="small">
        <p className="subheading text-gray-600"> {t('DASHBOARD.DemoFreeTrialFinished')}</p>
        <div className="rounded-md bg-[#FC7E00] px-2.5 py-1.5 text-white">
          {freeTrialBlock?.counter} {t('DASHBOARD.days')}
        </div>
      </Flex>
    </div>
  );
};
